import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Tabs, Tab } from "../BaseComponents";
import { Projects } from "./ProjectDataManager";
import { PresetManager } from "./PresetDataManager/PresetManager";
import { UserManager } from "./UserManager";
import { siftActions } from "../Redux";

const DataManager = () => {
  const dispatch = useDispatch();

  const email = useSelector((state) => state.user.email);
  const user_group = useSelector((state) => state.user.user_group);
  const [user_group_admin, set_user_group_admin] = useState(false);
  const tab = useSelector((state) => state.sift.ioManager.uiState.tab);

  const [activeKey, setActiveKey] = useState(tab);

  useEffect(() => {
    if (tab === activeKey) return;
    setActiveKey(tab);
  }, [tab]);

  useEffect(() => {
    if (!email || !user_group) return;
    const index = Object.values(user_group).findIndex((user) => user.email === email);
    const group_admin = Object.values(user_group)[index].group_admin;
    set_user_group_admin(group_admin);
  }, [user_group]);

  const handleTabChange = (e) => {
    setActiveKey(e);
    dispatch(siftActions.updateTab(e));
  };

  return (
    <Tabs defaultActiveKey={activeKey} onChange={handleTabChange}>
      <Tab key="projects" eventKey="projects" label="Projects">
        <Projects />
      </Tab>
      {user_group_admin && (
        <Tab key="presets" eventKey="presets" label="Presets">
          <PresetManager />
        </Tab>
      )}
      {user_group_admin && (
        <Tab key="users" eventKey="users" label="Users">
          <UserManager />
        </Tab>
      )}
    </Tabs>
  );
};

export { DataManager };
